const FOCUSABLE = [
  'a[href]',
  'area[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'iframe',
  '[tabindex]:not([tabindex="-1"])',
  '[contenteditable="true"]'
].join(',')

export const focusableElements = (container: HTMLElement): HTMLElement[] =>
  Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE))

// Keeps Tab / Shift+Tab cycling within the container.
export const trapTab = (event: KeyboardEvent, container: HTMLElement): void => {
  const elements = focusableElements(container)
  if (elements.length === 0) {
    event.preventDefault()
    return
  }

  const first = elements[0]
  const last = elements[elements.length - 1]
  const active = document.activeElement

  if (event.shiftKey && (active === first || active === container)) {
    event.preventDefault()
    last.focus()
  } else if (!event.shiftKey && active === last) {
    event.preventDefault()
    first.focus()
  }
}
